export default "__VITE_ASSET__iMoil$6___"